import type { InboxWorkflowCommitRowResult } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"

const objectValue = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {}

const uniqueIds = (ids: string[]) => {
  const seen = new Set<string>()
  const result: string[] = []
  for (const id of ids) {
    const text = String(id ?? "").trim()

    if (!text || seen.has(text)) continue

    seen.add(text)
    result.push(text)
  }

  return result
}

export const manualDeliveryItemIdsFromDecisionResultRows = (
  rows: readonly InboxWorkflowCommitRowResult[] | null | undefined,
) => {
  const manualIds: string[] = []
  for (const row of rows ?? []) {
    if (row.status !== "success") continue

    const decision = objectValue(row.output.letter_delivery_decision)

    if (decision.delivery_mode !== "manual") continue

    const itemId = String(decision.letter_delivery_batch_item_id ?? "").trim()

    if (itemId) manualIds.push(itemId)
  }

  return uniqueIds(manualIds)
}
